// extracted by mini-css-extract-plugin
export default {"filtration_wrapper":"UnrecognizedTesting_filtration_wrapper__645dj","filtration_title":"UnrecognizedTesting_filtration_title__xVxsd"};